
import markdown from 'markdown-it';

export default {
    name: 'CampaignContributionLegal',
    props: {
        campaign: Object,
    },
    computed: {
        parsedContent() {
            const md = markdown({
                html: true,
                linkify: true,
                typographer: true,
            });

            return md.render(this.legal);
        },
        legal() {
            if (this.$route.query.legal === 'terms') {
                return this.campaign.termsText;
            } else if (this.$route.query.legal === 'privacy') {
                return this.campaign.privacyText;
            } else {
                console.error('Unexpected legal type');
                return '';
            }
        },
    },
};
